import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "25",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 .5h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "m12 21.5-1.45-1.3q-2.525-2.274-4.175-3.925T3.75 13.313Q2.775 12 2.388 10.9A6.7 6.7 0 0 1 2 8.65Q2 6.3 3.575 4.725T7.5 3.15q1.3 0 2.475.55A5.9 5.9 0 0 1 12 5.25a5.9 5.9 0 0 1 2.025-1.55 5.8 5.8 0 0 1 2.475-.55q2.35 0 3.925 1.575T22 8.65q0 1.15-.387 2.25-.388 1.1-1.363 2.413t-2.625 2.962T13.45 20.2zm0-2.7a109 109 0 0 0 3.95-3.687q1.55-1.538 2.45-2.675t1.25-2.025T20 8.65q0-1.5-1-2.5t-2.5-1a3.86 3.86 0 0 0-2.175.663q-1 .663-1.375 1.687h-1.9q-.375-1.024-1.375-1.687A3.86 3.86 0 0 0 7.5 5.15q-1.5 0-2.5 1t-1 2.5q0 .875.35 1.763t1.25 2.025 2.45 2.675A109 109 0 0 0 12 18.8"
      })
    ], -1)
  ])))
}
export default { render: render }